import { z } from "zod";
import { loose, defineExperiment } from "../defineExperiment";

export const MAC_IN_REVIEW = defineExperiment("MAC_IN_REVIEW", {
  enabled: loose.boolean(),
  version_in_review: z.coerce.string().default(""),
});
